import React from "react";
import { Header, Grid, Segment, Image } from "semantic-ui-react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const CampaniaGenericoCard = ({ campania }) => {
  //states
  //actions

  return (
    <Segment>
      <Grid stackable columns={3} style={{ marginTop: "0.1em" }}>
        <Grid.Row>
          <Grid.Column width={5}></Grid.Column>
          <Grid.Column width={6}>
            <Image
              src="/assets/images/campania-generico-premia.png"
              size="small"
              centered={true}
            />
            <br />
            <Header
              as="h4"
              color="blue"
              textAlign="center"
              content={`${campania.descripcionTituloCampania}`}
            />
            <Header
              as="h5"
              color="violet"
              textAlign="center"
              content={`${campania.descripcionCuerpoCampania}`}
            />
            <Header
              as="h5"
              color="grey"
              textAlign="center"
              content={`${campania.descripcionPieCampania}`}
            />
          </Grid.Column>
          <Grid.Column width={5}></Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

CampaniaGenericoCard.propTypes = {
  campania: PropTypes.object.isRequired,
};

export default connect(null, null)(CampaniaGenericoCard);
